"use client";
import PropertiesData from "./PropertiesData";
import PropertiesSidebar from "./PropertiesSidebar";

export default function Properties() {
  return (
    <div className="my-9 flex flex-col md:flex-row gap-8 items-start justify-start">
      <PropertiesSidebar />
      <PropertiesData />
    </div>
  );
}
